import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import {Box} from "@material-ui/core";
import {useHistory, useLocation} from "react-router-dom";

import LoaderWithBackDrop from "../../../components/LoaderWithBackDrop/LoaderWithBackDrop.comp";
import OverallEfficacyTab from "./components/OverallEfficacy.comp";
import BreakdownEfficacy from "./components/BreakdownEfficacy.comp";
import OverallEfficacy from "./components/OverallEfficacy.comp";
import {GET_APP_LOCALIZE_TEXT} from "../../../utils/dq_lc_service/lc_service";

function TabPanel({children, value, index}) {
    return value === index && <Box py={3}>{children}</Box>;
}

function getEfficacyTabs(selectedTab, setSelectedTab, pageLc) {
    return [
        {
            key: "overall",
            label: GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__overall_efficacy") || "OVERALL EFFICACY",
            path: "overall",
            component: (
                <OverallEfficacy
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                />
            ),
        },
        {
            key: "breakdown",
            label: GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__efficacy_breakdown") || "EFFICACY BREAKDOWN",
            path: "breakdown",
            component: (
                <BreakdownEfficacy
                    selectedTab={selectedTab}
                    setSelectedTab={setSelectedTab}
                />
            ),
        },
    ];
}

function SchoolEfficacy() {
    const location = useLocation();
    const history = useHistory();
    const {pathname} = location;
    const pageLc = pathname.split('/')[1];
    const basePath = `/${pageLc}/school/efficacy`;

    const [loading, setLoading] = useState(false);
    const [selectedTab, setSelectedTab] = useState(0);

    const tabDefs = getEfficacyTabs(
        selectedTab,
        setSelectedTab,
        pageLc
    );

    const currentTabIdx = tabDefs.findIndex(tab =>
        pathname.startsWith(`${basePath}/${tab.path}`)
    );

    useEffect(() => {
        if (currentTabIdx === -1) {
            history.replace(`${basePath}/overall`);
        }
    }, [pathname]);

    return (
        <React.Fragment>
            <Helmet title={GET_APP_LOCALIZE_TEXT(pageLc, "efficacy__title") || "Efficacy Enhancement"}/>
            <Box width="100%" py={4}>
                {tabDefs.map((tabDef, idx) => (
                    <TabPanel key={tabDef.key} value={currentTabIdx === -1 ? 0 : currentTabIdx} index={idx}>
                        {tabDef.component}
                    </TabPanel>
                ))}
            </Box>
            <LoaderWithBackDrop loading={loading}/>
        </React.Fragment>
    );
}

export default SchoolEfficacy;
